import { render, staticRenderFns } from "./reportarSituacoes.vue?vue&type=template&id=3ec6d5b8&scoped=true&"
import script from "./reportarSituacoes.vue?vue&type=script&lang=js&"
export * from "./reportarSituacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec6d5b8",
  null
  
)

export default component.exports